<template #id>
    <div style="width: 90vw; height: 80vh; min-width: 1280px;">
      <div style="display: flex; flex-direction: column; flex: 1; height: 80vh; min-width: 1280px;">
        <ejs-grid ref="grid" height="100%" width="100%" :toolbar="toolbar" :toolbarClick="toolbarClick" :selectionSettings="selectionOptions" :allowTextWrap="true" :textWrapSettings="wrapSettings" :dataBound="dataBound" :dataSource="data" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true">
          <e-columns>
					  <e-column field="updateDate" :headerText="$t('UpdateDate')" textAlign="Left" :customAttributes="customAttributes" width="170" type="datetime" :format="dateTimeFormatOptions"></e-column>
					  <e-column field="leftTare" :headerText="$t('LeftTare')" textAlign="Left" :customAttributes="customAttributes" width="120" ></e-column>
					  <e-column field="leftCalibration" :headerText=" $t('LeftCalibration')" textAlign="Left" :customAttributes="customAttributes" width="160" ></e-column>
					  <e-column field="rightTare" :headerText=" $t('RightTare')" textAlign="Left" :customAttributes="customAttributes" width="130" ></e-column>
					  <e-column field="rightCalibration" :headerText=" $t('RightCalibration')" textAlign="Left" :customAttributes="customAttributes" width="170"></e-column>
					  <e-column field="tare" :headerText=" $t('Tare')" textAlign="Left" :customAttributes="customAttributes" width="100" ></e-column>
					  <e-column field="calibration" :headerText=" $t('Calibration')" textAlign="Left" :customAttributes="customAttributes" width="150" ></e-column>
					  <e-column field="tareCalibration" :headerText=" $t('TareCalibration')" textAlign="Left" :customAttributes="customAttributes" width="160" ></e-column>
					  <e-column field="version1" :headerText=" $t('Version') + ' 1'" textAlign="Left" :customAttributes="customAttributes" width="120" ></e-column>
					  <e-column field="version2" :headerText=" $t('Version') + ' 2'" textAlign="Left" :customAttributes="customAttributes" width="120"></e-column>
					  <e-column field="version3" :headerText=" $t('Version') + ' 3'" textAlign="Left" :customAttributes="customAttributes" width="120"></e-column>
          </e-columns>
        </ejs-grid>
		  </div>
    </div>
</template>

<script>
import { getLoadCellDataHistory } from '@api'
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import Vue from 'vue'

export default {
    props: ['systemId', 'deviceId'],
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport ]
    },
    data() {
        return {
			    data: [],
          pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
          toolbar: [
                    { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right',},
                    { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export'},
                    { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export'},
                    { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export'},

            'Search',
          ],
          wrapSettings: { wrapMode: "Content" },
          selectionOptions: { type: "Multiple" },
          filterOptions: {
            type: "Menu",
          },
          customAttributes : {class: 'customcss'},
          sortingModes: [],
          dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type:'dateTime'},
        }
    },
    methods: {
      async getData() {
        this.data = [];
        this.data = await getLoadCellDataHistory(this.systemId, this.deviceId);
      },
      toolbarClick: function(args) {
            switch(args.item.id){
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
      dataBound: function () {
        this.$refs.grid.autoFitColumns();
      },
    },
    mounted: async function() {
        await this.getData();
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Devices/LoadCellDataModal.vue